import { HttpParams } from '@angular/common/http';
import { TuwaiqConfig } from './constants/tuwaiq.config';

export class TuwaiqUtil {
    public static convertObjectKeysToCamelCase(list: any): any {
        if (list) {
            Object.keys(list).forEach((key: any) => {
                if (list[key] != null) {
                    this.convertKeysToCamelCase(list[key]);
                    if (list[key] instanceof Object || list[key] instanceof Array) {
                        this.convertObjectKeysToCamelCase(list[key]);
                    }
                }
            });
        }
        return list;
    }
    public  static convertKeysToCamelCase(object: any): any {
        Object.keys(object).forEach((key: string) => {
            if (key.includes('-')) {
                let newKey: string = key.replace(/-./g, x => x[1].toUpperCase());
                object[newKey] = object[key];
                delete object[key];
            }
        });
        return object;
    }

    public static isWebView() {
        const userAgent = navigator.userAgent || navigator.vendor || window['opera'];
        // Detect WebView on iOS
        const isiOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent);
        // Detect WebView on Android (this might need adjustments for specific cases)
        const isAndroidWebView = userAgent.indexOf('wv') > -1 && /Android/i.test(userAgent);
        return isiOSWebView || isAndroidWebView;
    }

    public static convertObjectKeysToKebabCase(o: any): any {
        let object: any = JSON.parse(JSON.stringify(o));
        return this.convertClonedObjectKeysToKebabCase(object);
    }

    private static convertClonedObjectKeysToKebabCase(object: any): any {
        if (object) {
            Object.keys(object).forEach((key: any) => {
                let newKey: string =
                    object instanceof Array
                        ? key
                        : key
                              .split('')
                              .map((letter: any, idx: number) => {
                                  return letter.toUpperCase() === letter && letter !== '-' ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}` : letter;
                              })
                              .join('');
                object[newKey] = object[key];
                if (newKey !== key) {
                    delete object[key];
                }
                if (object[newKey] instanceof Object || object[newKey] instanceof Array) {
                    this.convertClonedObjectKeysToKebabCase(object[newKey]);
                }
            });
        }
        return object;
    }

    setPaginationQueryParams(queryParams: HttpParams, page: number, size: number): HttpParams {
        queryParams = queryParams.set(TuwaiqConfig.REQUEST_QUERY_PARAMS.PAGE, page);
        queryParams = queryParams.set(TuwaiqConfig.REQUEST_QUERY_PARAMS.SIZE, size);
        return queryParams;
    }
}
